import { CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Layout grid for a `LocationCard`. Each part claims a named area
 * (`image`, `header`, `actions`, `notice`, `fields`), so the same children
 * rearrange per breakpoint without being rendered twice:
 *
 * - xs: image banner / header / notice / fields / actions, one column
 * - sm: image beside header, then notice, fields, actions full width
 * - md: image, header and actions on one row, then notice and fields
 * - lg+: a large 4:3 photo column on the left; header and actions, then
 *   notice and fields, sit beside it
 *
 * Rows have no gap of their own (an absent notice would leave an empty gap);
 * each part adds its own top margin where it needs one.
 */
const LocationCardContent = styled(CardContent)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr)",
  gridTemplateAreas: '"image" "header" "notice" "fields" "actions"',
  columnGap: 20,
  padding: 16,
  "&:last-child": { paddingBottom: 16 },
  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "auto minmax(0, 1fr)",
    gridTemplateAreas: '"image header" "notice notice" "fields fields" "actions actions"',
    padding: "16px 20px",
    "&:last-child": { paddingBottom: 16 },
  },
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "auto minmax(0, 1fr) auto",
    gridTemplateAreas: '"image header actions" "notice notice notice" "fields fields fields"',
  },
  // Any height the photo adds beyond the content goes to the last row, so the
  // header and field panels keep their natural size.
  [theme.breakpoints.up("lg")]: {
    gridTemplateRows: "auto auto 1fr",
    gridTemplateAreas: '"image header actions" "image notice notice" "image fields fields"',
  },
}));

export default LocationCardContent;
